import { breakpoints, useMatchMedia, useMediaQuery } from '@frontend/responsiveness';

export const useIsMobile = (): boolean => {
  const isSmall = useMatchMedia({ maxWidth: breakpoints.small.max });
  const isScreen = useMediaQuery('screen');
  return isSmall && isScreen;
};
